import { QueryParameter } from "./common";
import { InquiryForm } from "./inquiry-form";

export default class ProductInquiryFormLink {
    private linkElement: HTMLAnchorElement;
    private productId: number;
    private isForPrinting: boolean;

    constructor(linkElement: HTMLAnchorElement) {
        this.linkElement = linkElement;
        this.productId = Number(this.linkElement.dataset.productId);
        this.isForPrinting = this.linkElement.hasAttribute("data-for-printing");
    }

    init(): void {
        this.linkElement.addEventListener('click', evt => {
            const parameters: QueryParameter[] = [{ key: 'productId', value: this.productId }];
            if (this.isForPrinting) {
                parameters.push({ key: 'isForPrinting', value: 'true' });
            }
            new InquiryForm().openInPopup(evt, parameters);
        });
    }
}
